import { render } from "@testing-library/react";
import React, { useState, useEffect, useCallback } from "react";
import "../Styling/applepay.css";
import { isSafari } from "react-device-detect";

// USED BY FINIX ONLY. STRIPE USES EXPRESS CHECKOUT

const merchantIdentity =
  process.env.REACT_APP_ENVIRONMENT === "development"
    ? "IDdhuVDUcuSbMKK8LodmL4j2"
    : "IDh78D1ZEt9C2gsATdobvEWc";

// ------------------ Start of Apple Pay Session Code if hosted on donation.dot.ngo ------------------

function applePaySession(props) {
  const applePaySession = new window.ApplePaySession(6, {
    countryCode: "US",
    currencyCode: "USD",
    merchantCapabilities: ["supports3DS"],
    supportedNetworks: ["visa", "masterCard", "amex", "discover"],
    total: { label: props.sponsee, amount: props.total },
    requiredBillingContactFields: ["postalAddress", "name", "email", "phone"],
    requiredShippingContactFields: ["postalAddress", "name", "email", "phone"],
  });

  applePaySession.begin();

  applePaySession.onvalidatemerchant = async (event) => {
    try {
      var validationURL = event.validationURL;
      let hostname = window.location.hostname.replace(/^(https):\/\//, "");

      if (validationURL) {
        var request = JSON.stringify({
          validationURL: validationURL,
          merchantIdentity: merchantIdentity,
          domainName: hostname,
          displayName: props.sponsee,
        });
        let response = await fetch(
          process.env.REACT_APP_APPLE_PAY_CREATE_SESSION_URL,
          {
            method: "POST",
            body: request,
          }
        );
        response = await response.json();
        const sessionDetails = response["sessionDetails"];
        let merchantSession = JSON.parse(sessionDetails);
        applePaySession.completeMerchantValidation(merchantSession);
      }
    } catch (err) {
      console.log(err);
      throw err;
    }
  };

  // step 6 create a payment
  applePaySession.onpaymentauthorized = (event) => {
    try {
      //token received from Apple
      var paymentToken = event.payment;

      if (paymentToken) {
        // send Finix API stringified form of the token
        var stringifiedPaymentToken = JSON.stringify(paymentToken);
        applePaySession.completePayment(applePaySession.STATUS_SUCCESS);
        props.setLoad(true);
        props.makeApplePayPayment(stringifiedPaymentToken);
      } else {
        applePaySession.completePayment(applePaySession.STATUS_FAILURE);
      }
    } catch (err) {
      console.log(err);
      throw err;
    }
  };
}

// ------------------ End of Apple Pay Session Code ------------------

// ------------------ React Component ------------------

export default function ApplePay(props) {
  const [shookHands, setShookHands] = useState(false);
  const [isIframe, setIsIframe] = useState(false);
  const [timePassed, setTimePassed] = useState(0);

  function handler(event) {
    // handshake handler to verify if apple pay is enabled
    // using UUID to verify same session
    if (event.data.type === "scriptHandshake") {
      setShookHands(true);
    }

    // apple pay session token retrieval handler
    // using UUID to verify same session
    if (event.data.type === "applePayToken") {
      props.setLoad(true);
      const paymentToken = JSON.parse(event.data.token);
      const shippingInfo = paymentToken.shippingContact;
      props.makeApplePayPayment(event.data.token);
    }
  }

  useEffect(() => {
    if (window.location.ancestorOrigins.length == 0) {
      props.setShowApplePay(true);
    } else {
      setIsIframe(true);
      window.addEventListener("message", handler);

      // initiate handshake
      window.parent.postMessage(
        {
          type: "iframeHandshake",
          sponsee: props.sponsee,
          total: props.total,
          merchantIdentity: merchantIdentity,
          createApplePaySessionURL:
            process.env.REACT_APP_APPLE_PAY_CREATE_SESSION_URL,
          uuid: props.uuid,
        },
        "*"
      );
      // console.log('sent message')
      return () => {
        window.removeEventListener("message", handler);
      };
    }
  }, []);

  // set showApplePay to true if handshake is successful
  useEffect(() => {
    if (shookHands) {
      console.log("setting showApplePay to true");
      props.setShowApplePay(true);
    }
  }, [shookHands]);

  // If not a safari browser, return an empty div
  if (!isSafari) {
    return <></>;
  }

  // If not in iframe, return button click to trigger apple pay session from react component
  if (!isIframe) {
    return (
      <>
        <button
          style={{
            width: "100%",
            height: "50px",
            backgroundColor: "#000000",
            borderRadius: "5px",
            cursor: "pointer",
          }}
          className="ApplePayButton"
          onClick={(e) => {
            e.preventDefault();
            applePaySession(props);
          }}
        >
          <svg
            style={{ display: "block" }}
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            role="img"
            width="100%"
            height="30px"
            preserveAspectRatio="xMidYMid meet"
            viewBox="0 0 512 211"
          >
            <path
              d="M93.552 27.103c-6 7.1-15.602 12.702-25.203 11.901c-1.2-9.6 3.5-19.802 9.001-26.103C83.35 5.601 93.852.4 102.353 0c1 10.001-2.9 19.802-8.8 27.103Zm8.701 13.802c-13.902-.8-25.803 7.9-32.404 7.9c-6.7 0-16.802-7.5-27.803-7.3c-14.301.2-27.603 8.3-34.904 21.202c-15.002 25.803-3.9 64.008 10.601 85.01c7.101 10.401 15.602 21.802 26.803 21.402c10.602-.4 14.802-6.9 27.604-6.9c12.901 0 16.602 6.9 27.803 6.7c11.601-.2 18.902-10.4 26.003-20.802c8.1-11.801 11.401-23.303 11.601-23.903c-.2-.2-22.402-8.7-22.602-34.304c-.2-21.402 17.502-31.603 18.302-32.203c-10.002-14.802-25.603-16.402-31.004-16.802Zm80.31-29.004V167.82h24.202v-53.306h33.504c30.603 0 52.106-21.002 52.106-51.406c0-30.403-21.103-51.206-51.306-51.206h-58.507Zm24.202 20.403h27.903c21.003 0 33.004 11.201 33.004 30.903c0 19.702-12.001 31.004-33.104 31.004h-27.803V32.304ZM336.58 169.019c15.202 0 29.303-7.7 35.704-19.902h.5v18.702h22.403V90.21c0-22.502-18.002-37.004-45.706-37.004c-25.703 0-44.705 14.702-45.405 34.904h21.803c1.8-9.601 10.7-15.902 22.902-15.902c14.802 0 23.103 6.901 23.103 19.603v8.6l-30.204 1.8c-28.103 1.7-43.304 13.202-43.304 33.205c0 20.202 15.701 33.603 38.204 33.603Zm6.5-18.502c-12.9 0-21.102-6.2-21.102-15.702c0-9.8 7.901-15.501 23.003-16.401l26.903-1.7v8.8c0 14.602-12.401 25.003-28.803 25.003Zm82.01 59.707c23.603 0 34.704-9 44.405-36.304L512 54.706h-24.603l-28.503 92.11h-.5l-28.503-92.11h-25.303l41.004 113.513l-2.2 6.901c-3.7 11.701-9.701 16.202-20.402 16.202c-1.9 0-5.6-.2-7.101-.4v18.702c1.4.4 7.4.6 9.201.6Z"
              fill="#fff"
            />
          </svg>
        </button>
      </>
    );
  }

  // If apple pay script is not present and it's embedded as an iframe, return an empty div
  if (!shookHands && isIframe) {
    return <></>;
  }

  // otherwise return apple button (apple pay script is present and is an iframe)
  return (
    <>
      <button
        style={{
          width: "100%",
          height: "50px",
          backgroundColor: "#000000",
          borderRadius: "5px",
          cursor: "pointer",
        }}
        className="ApplePayButton"
        onClick={(e) => {
          e.preventDefault();
          const paymentTypeChangeEvent = { target: { id: "card" } };
          props.handlePaymentTypeChange(paymentTypeChangeEvent);
          // console.log(window.origin);
          // console.log(window.location.ancestorOrigins[0])
          // console.log('posting message');
          if (props.schedulePaymentShowComponent() === false) {
            // only send message if schedule payment modals are closed
            window.parent.postMessage(
              {
                type: "applePay",
                sponsee: props.sponsee,
                total: props.total,
                merchantIdentity: merchantIdentity,
                createApplePaySessionURL:
                  process.env.REACT_APP_APPLE_PAY_CREATE_SESSION_URL,
                uuid: props.uuid,
              },
              "*"
            );
          }
        }}
      >
        <svg
          style={{ display: "block" }}
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
          role="img"
          width="100%"
          height="30px"
          preserveAspectRatio="xMidYMid meet"
          viewBox="0 0 512 211"
        >
          <path
            d="M93.552 27.103c-6 7.1-15.602 12.702-25.203 11.901c-1.2-9.6 3.5-19.802 9.001-26.103C83.35 5.601 93.852.4 102.353 0c1 10.001-2.9 19.802-8.8 27.103Zm8.701 13.802c-13.902-.8-25.803 7.9-32.404 7.9c-6.7 0-16.802-7.5-27.803-7.3c-14.301.2-27.603 8.3-34.904 21.202c-15.002 25.803-3.9 64.008 10.601 85.01c7.101 10.401 15.602 21.802 26.803 21.402c10.602-.4 14.802-6.9 27.604-6.9c12.901 0 16.602 6.9 27.803 6.7c11.601-.2 18.902-10.4 26.003-20.802c8.1-11.801 11.401-23.303 11.601-23.903c-.2-.2-22.402-8.7-22.602-34.304c-.2-21.402 17.502-31.603 18.302-32.203c-10.002-14.802-25.603-16.402-31.004-16.802Zm80.31-29.004V167.82h24.202v-53.306h33.504c30.603 0 52.106-21.002 52.106-51.406c0-30.403-21.103-51.206-51.306-51.206h-58.507Zm24.202 20.403h27.903c21.003 0 33.004 11.201 33.004 30.903c0 19.702-12.001 31.004-33.104 31.004h-27.803V32.304ZM336.58 169.019c15.202 0 29.303-7.7 35.704-19.902h.5v18.702h22.403V90.21c0-22.502-18.002-37.004-45.706-37.004c-25.703 0-44.705 14.702-45.405 34.904h21.803c1.8-9.601 10.7-15.902 22.902-15.902c14.802 0 23.103 6.901 23.103 19.603v8.6l-30.204 1.8c-28.103 1.7-43.304 13.202-43.304 33.205c0 20.202 15.701 33.603 38.204 33.603Zm6.5-18.502c-12.9 0-21.102-6.2-21.102-15.702c0-9.8 7.901-15.501 23.003-16.401l26.903-1.7v8.8c0 14.602-12.401 25.003-28.803 25.003Zm82.01 59.707c23.603 0 34.704-9 44.405-36.304L512 54.706h-24.603l-28.503 92.11h-.5l-28.503-92.11h-25.303l41.004 113.513l-2.2 6.901c-3.7 11.701-9.701 16.202-20.402 16.202c-1.9 0-5.6-.2-7.101-.4v18.702c1.4.4 7.4.6 9.201.6Z"
            fill="#fff"
          />
        </svg>
      </button>
    </>
  );
}
